import Lottie from "lottie-react";
import successrole from "../Json/successrole.json";

const Successrole = () => {
  return (
    <div>
      <div
        style={{
          width: "150px",
          height: "150px",
          margin: "0px auto",
        }}
      >
        <Lottie animationData={successrole} loop={true} />
      </div>
    </div>
  );
};
export default Successrole;
